import { render, staticRenderFns } from "./UserOvpList.vue?vue&type=template&id=443fde72&"
import script from "./UserOvpList.vue?vue&type=script&lang=js&"
export * from "./UserOvpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports